<div class="page-header-container">
    <div class="page-title">
        {{ 'contracts.clientContracts' | translate}}
    </div>
</div>

<div class="header-buttons-box">
    <div class="custom-text-input-container search-container flex-grow-1">
        <kendo-autocomplete HJSuppress
            rounded="large"
            [data]="autocompleteDatasource"
            [filterable]="true"
            [valueField]="'name'"
            [placeholder]="'users.companySearchPlaceholder' | translate"
            [clearButton]="true"
            [(ngModel)]="autocompleteValue.value"
            (ngModelChange)="partnerSelectedHandler($event)"
            (filterChange)="filterDataSource($event)"
        >
            <ng-template kendoPrefixTemplate>
                <i class="app-icon icon icon-search icon-xl2"></i>
            </ng-template>

            <ng-template kendoAutoCompleteItemTemplate let-dataItem>
                <div HJSuppress class="autocomplete-template-container fw-semibold">
                    <span class="autocomplete-main-label">{{dataItem?.name}}</span>
                    <span class="autocomplete-second-label text-secondary" *ngIf="dataItem.uniqueIdentifier">
                    {{'users.cui' | translate}}: {{dataItem?.uniqueIdentifier}}
                    </span>
                    <span class="autocomplete-second-label text-secondary" *ngIf="!dataItem.uniqueIdentifier">
                    {{'users.code' | translate}}: {{dataItem?.code}}
                    </span>
                </div>
            </ng-template>

            <ng-template kendoAutoCompleteNoDataTemplate>
                <span *ngIf="partnerSearchValue?.length < 3">{{'users.searchPartnerInfo' | translate}}</span>
                <span *ngIf="partnerSearchValue?.length >= 3 && !hasPartners">{{'common.noData' | translate}}</span>
            </ng-template>
        </kendo-autocomplete>

        <i *ngIf="partnerSearchValue?.length < DEFAULT_DEBOUNCE_CHARACTERS"
            class="app-icon icon icon-info-circle-fill icon-xl text-warning" 
            [ngbPopover]="partnerFilterInfo" 
            triggers="mouseenter:mouseleave">
        </i>

        <ng-template #partnerFilterInfo>
            <span>{{'contracts.partnerFilterInfo' | translate}}</span>
        </ng-template>
    </div>

    <button class="btn white-btn text-uppercase" (click)="toggleContractListStateHandler()" [disabled]="autocompleteValue?.id === undefined">
        <span>
            {{ (contractsFilter.activeContracts ? 'contracts.viewClosedContracts' : 'contracts.viewActiveContracts') | translate | uppercase}}
        </span>
    </button>
    
    <button *ngIf="activeFilterCount <= 0" class="btn white-btn text-uppercase" (click)="filterHandler()" [disabled]="autocompleteValue?.id === undefined">
        {{'contracts.filter' | translate}}
    </button>
    
    <div class="buttons-group-box active-filters-reset" *ngIf="activeFilterCount > 0">
        <div class="btn-group" role="group">
            <button class="btn white-btn text-uppercase" (click)="filterHandler()">
                <span>{{'contracts.filterActive' | translate}}</span>
            </button>
            <button class="btn white-btn" (click)="resetFiltersHandler()">
                <span class="active-filters-badge">{{activeFilterCount}}</span>
                <i class="app-icon icon icon-close-circle-fill icon-lg"></i>
            </button>
        </div>
    </div>

    <div class="buttons-group-box table-view-mode-switch d-none d-lg-flex">
        <div class="btn-group" role="group">
            <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.LIST_VIEW)" 
                [disabled]="tableViewMode === TABLE_VIEW_MODES.LIST_VIEW">
                <i class="app-icon icon icon-view-list icon-lg me-2"></i>
                <span>{{'common.listView' | translate }}</span>
            </button>
            <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.CARDS_VIEW)" 
                [disabled]="tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW">
                <i class="app-icon icon icon-view-grid icon-lg me-2"></i>
                <span>{{'common.cardsView' | translate }}</span>
            </button>
        </div>
    </div>        
</div>

<div class="d-flex flex-column align-items-center my-5 my-lg-0" *ngIf="!hasData">
    <no-records-placeholder
        [showNoRecordsHeader]="true"
        [isActiveFilter]="activeFilterCount > 0"
        (clickHereEvent)="resetFiltersHandler(true)"
    ></no-records-placeholder>
</div>

<contracts-card-view 
    *ngIf="(tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW || !windowSizeLgUp) && hasData" 
    [contracts]="contracts" 
    [props]="contractsProps" 
    (viewDetails)="null">
</contracts-card-view>
<contracts-list-view 
    *ngIf="(tableViewMode === TABLE_VIEW_MODES.LIST_VIEW && windowSizeLgUp) && hasData" 
    [contracts]="contracts" 
    [props]="contractsProps" 
    (viewDetails)="null">
</contracts-list-view>

<button *ngIf="showBackToTop" type="button" class="btn btn-scroll-to-top" (click)="scrollToTop()">
    <i class="app-icon icon icon-back-to-top icon-xl"></i>
</button>
